export default "__VITE_ASSET__IjE7c2PB__"